import React from 'react';
import { Layout, Row, Col, Typography, Space, Divider } from 'antd';
import {
  GithubOutlined,
  WechatOutlined,
  QqOutlined,
  MailOutlined,
  EnvironmentOutlined,
  CopyrightOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Title, Text } = Typography;

const FooterItem = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { title: '首页', path: '/' },
    { title: '归档', path: '/archive' },
    { title: '写文章', path: '/write' },
    { title: '我的', path: '/about' },
    { title: '登录', path: '/auth' },
    { title: '隐私政策', path: '#' },
    { title: '服务条款', path: '#' },
    { title: '联系我们', path: '#' }
  ];

  const contactInfo = [
    { icon: <MailOutlined />, text: 'contact@myblog.com' },
    { icon: <EnvironmentOutlined />, text: '上海市浦东新区' },
  ];

  return (
    <AntFooter className="app-footer">
      <div className="footer-content">
        <Row gutter={[32, 32]} className="footer-links">
          {/* 关于博客 */}
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5} className="footer-title">关于博客</Title>
              <Text className="footer-description">
                这是一个个人技术博客，分享编程知识、生活感悟和技术经验。
                记录成长的每一步，与大家共同进步。
              </Text>
            </div>
          </Col>
          
          {/* 快速链接 */}
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5} className="footer-title">快速链接</Title>
              <div className="footer-list">
                {footerLinks.slice(0, 4).map((link, index) => (
                  <div key={index} className="footer-link-item">
                    <Link to={link.path} className="footer-link">
                      {link.title}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          
          {/* 帮助支持 */}
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5} className="footer-title">帮助支持</Title>
              <div className="footer-list">
                {footerLinks.slice(4).map((link, index) => (
                  <div key={index} className="footer-link-item">
                    <Link to={link.path} className="footer-link">
                      {link.title}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </Col>
          
          {/* 联系我 */}
          <Col xs={24} sm={12} md={6}>
            <div className="footer-section">
              <Title level={5} className="footer-title">联系我</Title>
              <div className="contact-list">
                {contactInfo.map((item, index) => (
                  <div key={index} className="contact-item">
                    <span className="contact-icon">{item.icon}</span>
                    <Text className="contact-text">{item.text}</Text>
                  </div>
                ))}
              </div>
              
              <Space size="middle" className="social-icons" style={{ marginTop: 16 }}>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <GithubOutlined />
                </a>
                <a href="#" className="social-icon">
                  <WechatOutlined />
                </a>
                <a href="#" className="social-icon">
                  <QqOutlined />
                </a>
              </Space>
            </div>
          </Col>
        </Row>
        
        <Divider className="footer-divider" />
        
        {/* 底部版权信息 */}
        <div className="footer-bottom">
          <Row justify="space-between" align="middle">
            <Col>
              <Space size="small">
                <CopyrightOutlined style={{ color: 'rgba(255, 255, 255, 0.65)' }} />
                <Text type="secondary">
                  {currentYear} 我的博客 版权所有
                </Text>
              </Space>
            </Col>
            <Col>
              <Text type="secondary">
                备案号: <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                  沪ICP备12345678号
                </a>
              </Text>
            </Col>
          </Row>
        </div>
      </div>
    </AntFooter>
  );
};

export default FooterItem;